import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, TextBlock } from "./styles";

export const NotAuthorizedPage = () => {
  const [timer, setTimer] = useState<number>(5);
  const navigate = useNavigate();

  useEffect(() => {
    const timerId = setInterval(() => {
      setTimer((timer) => timer - 1);
    }, 1000);

    setTimeout(() => {
      clearInterval(timerId);
      navigate("/");
    }, 5000);

    return () => {
      clearInterval(timerId);
      setTimer(5);
    };
  }, []);

  return (
    <Container>
      <TextBlock>
        <span style={{ fontSize: "26px" }}>Not authorized, redirecting to dashboard after</span>
        <span style={{ fontWeight: "bold", fontSize: "26px" }}>{`${timer} seconds`}</span>
      </TextBlock>
    </Container>
  );
};
